import { render } from "./HeaderDetail.vue?vue&type=template&id=c92f296c"
import script from "./HeaderDetail.vue?vue&type=script&lang=js"
export * from "./HeaderDetail.vue?vue&type=script&lang=js"
script.render = render

export default script